module.exports = __webpack_public_path__ + "static/media/A6-portrait-v2.28b75e78.png";